import axios from '../../axios';

export default async function getCampaignSubRequest({
  code,
}: {
  code?: string;
}): Promise<void> {
  const response = await axios.get<void>(
    `${process.env.REACT_APP_BASE_URL}/users/campaign/sub`,
    {
      params: {
        code,
      },
    }
  );
  return response.data;
}
